var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wp-block-media-text",class:{
        'has-media-on-the-right': _vm.reverse,
        'is-stacked-on-mobile': true
    },style:(_vm.gridStyle)},[_c('figure',{staticClass:"wp-block-media-text__media"},[_c('img',{attrs:{"src":_vm.image,"alt":""}})]),_c('div',{staticClass:"wp-block-media-text__content"},[_c('h2',{staticClass:"media-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"media-text"},[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }